export enum ApplicationType {
  NewClientApplication = 1,
  JointAccountMaintenance = 2,
}

